import { graphql } from '@teachino/shared-infrastructure';
import { folderFragment } from './folder.fragment';

export const createFolderMutation = graphql(
  `
    mutation CreateFolder($name: String!, $parentFolderId: String) {
      createLibraryFolder(
        createLibraryFolderInput: {
          name: $name
          parentFolderId: $parentFolderId
        }
      ) {
        __typename
        libraryFolder {
          ...Folder
        }
      }
    }
  `,
  [folderFragment],
);
